import { css } from '@linaria/core'
import colors from './colors'

export const blueTheme = css`
  --color02: ${colors.blue02};
  --color02: ${colors.blue02};
  --color03: ${colors.blue03};
  --color05: ${colors.blue05};
  --color10: ${colors.blue10};
  --color20: ${colors.blue20};
  --color30: ${colors.blue30};
  --color40: ${colors.blue40};
  --color50: ${colors.blue50};
  --color60: ${colors.blue60};
  --color70: ${colors.blue70};
  --color80: ${colors.blue80};
  --color90: ${colors.blue90};
  --color02a: ${colors.transparent.blue02};
  --color02a: ${colors.transparent.blue02};
  --color03a: ${colors.transparent.blue03};
  --color05a: ${colors.transparent.blue05};
  --color10a: ${colors.transparent.blue10};
  --color20a: ${colors.transparent.blue20};
  --color30a: ${colors.transparent.blue30};
  --color40a: ${colors.transparent.blue40};
  --color50a: ${colors.transparent.blue50};
  --color60a: ${colors.transparent.blue60};
  --color70a: ${colors.transparent.blue70};
  --color80a: ${colors.transparent.blue80};
  --color90a: ${colors.transparent.blue90};
`

export const greenTheme = css`
  --color02: ${colors.green02};
  --color02: ${colors.green02};
  --color03: ${colors.green03};
  --color05: ${colors.green05};
  --color10: ${colors.green10};
  --color20: ${colors.green20};
  --color30: ${colors.green30};
  --color40: ${colors.green40};
  --color50: ${colors.green50};
  --color60: ${colors.green60};
  --color70: ${colors.green70};
  --color80: ${colors.green80};
  --color90: ${colors.green90};
  --color02a: ${colors.transparent.green02};
  --color02a: ${colors.transparent.green02};
  --color03a: ${colors.transparent.green03};
  --color05a: ${colors.transparent.green05};
  --color10a: ${colors.transparent.green10};
  --color20a: ${colors.transparent.green20};
  --color30a: ${colors.transparent.green30};
  --color40a: ${colors.transparent.green40};
  --color50a: ${colors.transparent.green50};
  --color60a: ${colors.transparent.green60};
  --color70a: ${colors.transparent.green70};
  --color80a: ${colors.transparent.green80};
  --color90a: ${colors.transparent.green90};
`

export const yellowTheme = css`
  --color02: ${colors.yellow02};
  --color02: ${colors.yellow02};
  --color03: ${colors.yellow03};
  --color05: ${colors.yellow05};
  --color10: ${colors.yellow10};
  --color20: ${colors.yellow20};
  --color30: ${colors.yellow30};
  --color40: ${colors.yellow40};
  --color50: ${colors.yellow50};
  --color60: ${colors.yellow60};
  --color70: ${colors.yellow70};
  --color80: ${colors.yellow80};
  --color90: ${colors.yellow90};
  --color02a: ${colors.transparent.yellow02};
  --color02a: ${colors.transparent.yellow02};
  --color03a: ${colors.transparent.yellow03};
  --color05a: ${colors.transparent.yellow05};
  --color10a: ${colors.transparent.yellow10};
  --color20a: ${colors.transparent.yellow20};
  --color30a: ${colors.transparent.yellow30};
  --color40a: ${colors.transparent.yellow40};
  --color50a: ${colors.transparent.yellow50};
  --color60a: ${colors.transparent.yellow60};
  --color70a: ${colors.transparent.yellow70};
  --color80a: ${colors.transparent.yellow80};
  --color90a: ${colors.transparent.yellow90};
`

export const dangerTheme = css`
  --color02: ${colors.danger02};
  --color02: ${colors.danger02};
  --color03: ${colors.danger03};
  --color05: ${colors.danger05};
  --color10: ${colors.danger10};
  --color20: ${colors.danger20};
  --color30: ${colors.danger30};
  --color40: ${colors.danger40};
  --color50: ${colors.danger50};
  --color60: ${colors.danger60};
  --color70: ${colors.danger70};
  --color80: ${colors.danger80};
  --color90: ${colors.danger90};
  --color02a: ${colors.transparent.danger02};
  --color02a: ${colors.transparent.danger02};
  --color03a: ${colors.transparent.danger03};
  --color05a: ${colors.transparent.danger05};
  --color10a: ${colors.transparent.danger10};
  --color20a: ${colors.transparent.danger20};
  --color30a: ${colors.transparent.danger30};
  --color40a: ${colors.transparent.danger40};
  --color50a: ${colors.transparent.danger50};
  --color60a: ${colors.transparent.danger60};
  --color70a: ${colors.transparent.danger70};
  --color80a: ${colors.transparent.danger80};
  --color90a: ${colors.transparent.danger90};
`

export const redTheme = css`
  --color02: ${colors.red02};
  --color02: ${colors.red02};
  --color03: ${colors.red03};
  --color05: ${colors.red05};
  --color10: ${colors.red10};
  --color20: ${colors.red20};
  --color30: ${colors.red30};
  --color40: ${colors.red40};
  --color50: ${colors.red50};
  --color60: ${colors.red60};
  --color70: ${colors.red70};
  --color80: ${colors.red80};
  --color90: ${colors.red90};
  --color02a: ${colors.transparent.red02};
  --color02a: ${colors.transparent.red02};
  --color03a: ${colors.transparent.red03};
  --color05a: ${colors.transparent.red05};
  --color10a: ${colors.transparent.red10};
  --color20a: ${colors.transparent.red20};
  --color30a: ${colors.transparent.red30};
  --color40a: ${colors.transparent.red40};
  --color50a: ${colors.transparent.red50};
  --color60a: ${colors.transparent.red60};
  --color70a: ${colors.transparent.red70};
  --color80a: ${colors.transparent.red80};
  --color90a: ${colors.transparent.red90};
`

export const grayTheme = css`
  --color02: ${colors.gray02};
  --color02: ${colors.gray02};
  --color03: ${colors.gray03};
  --color05: ${colors.gray05};
  --color10: ${colors.gray10};
  --color20: ${colors.gray20};
  --color30: ${colors.gray30};
  --color40: ${colors.gray40};
  --color50: ${colors.gray50};
  --color60: ${colors.gray60};
  --color70: ${colors.gray70};
  --color80: ${colors.gray80};
  --color90: ${colors.gray90};
  --color02a: ${colors.transparent.gray02};
  --color02a: ${colors.transparent.gray02};
  --color03a: ${colors.transparent.gray03};
  --color05a: ${colors.transparent.gray05};
  --color10a: ${colors.transparent.gray10};
  --color20a: ${colors.transparent.gray20};
  --color30a: ${colors.transparent.gray30};
  --color40a: ${colors.transparent.gray40};
  --color50a: ${colors.transparent.gray50};
  --color60a: ${colors.transparent.gray60};
  --color70a: ${colors.transparent.gray70};
  --color80a: ${colors.transparent.gray80};
  --color90a: ${colors.transparent.gray90};
`

export const purpleTheme = css`
  --color02: ${colors.purple02};
  --color02: ${colors.purple02};
  --color03: ${colors.purple03};
  --color05: ${colors.purple05};
  --color10: ${colors.purple10};
  --color20: ${colors.purple20};
  --color30: ${colors.purple30};
  --color40: ${colors.purple40};
  --color50: ${colors.purple50};
  --color60: ${colors.purple60};
  --color70: ${colors.purple70};
  --color80: ${colors.purple80};
  --color90: ${colors.purple90};
  --color02a: ${colors.transparent.purple02};
  --color02a: ${colors.transparent.purple02};
  --color03a: ${colors.transparent.purple03};
  --color05a: ${colors.transparent.purple05};
  --color10a: ${colors.transparent.purple10};
  --color20a: ${colors.transparent.purple20};
  --color30a: ${colors.transparent.purple30};
  --color40a: ${colors.transparent.purple40};
  --color50a: ${colors.transparent.purple50};
  --color60a: ${colors.transparent.purple60};
  --color70a: ${colors.transparent.purple70};
  --color80a: ${colors.transparent.purple80};
  --color90a: ${colors.transparent.purple90};
`

export const whiteTheme = css`
  --color02: ${colors.white02};
  --color03: ${colors.white03};
  --color05: ${colors.white05};
  --color10: ${colors.white10};
  --color20: ${colors.white20};
  --color30: ${colors.white30};
  --color40: ${colors.white40};
  --color50: ${colors.white50};
  --color60: ${colors.white60};
  --color70: ${colors.white70};
  --color80: ${colors.white80};
  --color90: ${colors.white90};
  --color02a: ${colors.white02};
  --color03a: ${colors.white03};
  --color05a: ${colors.white05};
  --color10a: ${colors.white10};
  --color20a: ${colors.white20};
  --color30a: ${colors.white30};
  --color40a: ${colors.white40};
  --color50a: ${colors.white50};
  --color60a: ${colors.white60};
  --color70a: ${colors.white70};
  --color80a: ${colors.white80};
  --color90a: ${colors.white90};

  --gray00: rgba(255, 255, 255, 0);
  --gray02: ${colors.white02};
  --gray03: ${colors.white03};
  --gray05: ${colors.white05};
  --gray10: ${colors.white10};
  --gray20: ${colors.white20};
  --gray30: ${colors.white30};
  --gray40: ${colors.white40};
  --gray50: ${colors.white50};
  --gray60: ${colors.white60};
  --gray70: ${colors.white70};
  --gray80: ${colors.white80};
  --gray90: ${colors.white90};
  --gray100: white;
  --gray02a: ${colors.white02};
  --gray03a: ${colors.white03};
  --gray05a: ${colors.white05};
  --gray10a: ${colors.white10};
  --gray20a: ${colors.white20};
  --gray30a: ${colors.white30};
  --gray40a: ${colors.white40};
  --gray50a: ${colors.white50};
  --gray60a: ${colors.white60};
  --gray70a: ${colors.white70};
  --gray80a: ${colors.white80};
  --gray90a: ${colors.white90};
  --gray100a: white;
  color: white;
  --gradient-color-base: 100%;
`

export default {
  blue: blueTheme,
  green: greenTheme,
  yellow: yellowTheme,
  red: redTheme,
  danger: dangerTheme,
  purple: purpleTheme,
  gray: grayTheme,
}
